import React from 'react'
import StatTableRow from "./SatTableRow/StatTabelRow";

const statTable = props => {

  return (
    <div>
      <div className="table-responsive">
        <div id="datatable1_wrapper" className="dataTables_wrapper no-footer">
          <div id="datatable1_filter" className="dataTables_filter">
            <label><i className="fa fa-search"> </i>&nbsp;Search by Country Name&nbsp;&nbsp;
              <input type="search" className="" placeholder="" aria-controls="datatable1"
                     onChange={event => props.onSearch(event)}/></label></div>
          <table id="datatable1" className="table table-striped table-hover dataTable no-footer table-responsive"
                 role="grid"
                 aria-describedby="datatable1_info">
            <thead>
            <tr role="row">
              <th className="sorting_desc" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Rendering engine: activate to sort column ascending" style={{width: "200px"}}
                  aria-sort="descending">Location
              </th>
              <th className="sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Browser: activate to sort column ascending" // style={{width: "315px"}}
              >Total Cases
              </th>
              <th className="sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Browser: activate to sort column ascending" // style={{width: "315px"}}
              >Yesterday Cases
              </th>
              <th className="sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Platform(s): activate to sort column ascending" // style={{width: "290px"}}
              >New Cases
              </th>
              <th className="sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Platform(s): activate to sort column ascending" // style={{width: "290px"}}
              >Total Deaths
              </th>
              <th className="sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Platform(s): activate to sort column ascending" // style={{width: "290px"}}
              >Yesterday Deaths
              </th>
              <th className="sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Platform(s): activate to sort column ascending" // style={{width: "290px"}}
              >New Deaths
              </th>
              <th className="sort-numeric sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="Engine version: activate to sort column ascending" // style={{width: "191px"}}
              >Total Recovered
              </th>
              <th className="sort-alpha sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="CSS grade: activate to sort column ascending" // style={{width: "148px"}}
              >Active Cases
              </th>
              {/*<th className="sort-alpha sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"*/}
              {/*aria-label="CSS grade: activate to sort column ascending" // style={{width: "148px"}}*/}
              {/*>Serious Critical*/}
              {/*</th>*/}
              <th className="sort-alpha sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="CSS grade: activate to sort column ascending" // style={{width: "148px"}}
              >Cases per Million
              </th>
              <th className="sort-alpha sorting" tabIndex="0" aria-controls="datatable1" rowSpan="1" colSpan="1"
                  aria-label="CSS grade: activate to sort column ascending" // style={{width: "148px"}}
              >Deaths per Million
              </th>
            </tr>
            </thead>
            <tbody>
            {props.currentStats.map((rowStats, index) =>
              <StatTableRow rowStats={rowStats} isOdd={(index % 2) === 0} key={rowStats.country}/>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
};

export default statTable;


